// Copyright (c) 2021, Picsa Advisory Services (Pty) Ltd. All rights reserved.

import React, { Component, createRef } from 'react'
import PropTypes from 'prop-types'

import { CsvToHtmlTable } from 'react-csv-to-table'

import {
  Spinner,
  Button,
  Modal,
  ExpandableSection
} from '../../'

const today = new Date()
const todayYearMonth = `${today.getFullYear()}-${("0" + (today.getMonth() + 1)).slice(-2)}`

const modalRef = createRef()


export class MonthlyBillingStats extends Component {
  state = {
    month: todayYearMonth,
    showReportGenerated: false,
    fetchInProgress: false,
    billingInfoFetched: null
  }

  componentDidMount() {
    document.addEventListener('mousedown', this.handleClickOutside)
  }

  componentWillUnmount() {
    document.removeEventListener('mousedown', this.handleClickOutside)
  }

  handleClickOutside = (e) => {
    if (modalRef.current && !modalRef.current.contains(e.target)) {
      // click is outside, close
      this.setState({ showReportGenerated: false })
    }
  }

  setMonth = (e) => (
    this.setState({ month: e.target.value })
  )

  generateReportForSelectedMonth = () => {
    this.fetchBillingReport()
  }

  toggleReportGenerated = () => (
    this.setState(prevState => (
      { showReportGenerated: !prevState.showReportGenerated }
    ))
  )

  getMonthNameFromIndex = (index) => (
    [
      'January', 'February', 'March', 'April', 'May', 'June',
      'July', 'August', 'September', 'October', 'November', 'December'
    ][parseInt(index, 10) - 1]
  )

  toggleFetchInProgress = () => (
    this.setState(prevState => (
      { fetchInProgress: !prevState.fetchInProgress }
    ))
  )

  fetchBillingReport = () => {
    this.toggleFetchInProgress()
    const month = parseInt(this.state.month.split('-')[1], 10)
    const year = this.state.month.split('-')[0]

    fetch(`${process.env.REACT_APP_API_ROOT}/v1/billing_report/${month}/${year}`)
    .then(response => {
      if (response.ok) {
        response.json()
          .then(result => this.setState({ billingInfoFetched: result }))
          .then(this.toggleReportGenerated)
          .then(this.toggleFetchInProgress)
      } else {
        console.error('Failed to fetch billing report')
        this.toggleFetchInProgress()
      }

    })
    .catch(error => {
      console.error(`Failed to fetch billing report - ${error}`)
      this.toggleFetchInProgress()
    })
  }

  render() {
    const { show, toggleShow, className, style } = this.props
    const { month, showReportGenerated, fetchInProgress, billingInfoFetched } = this.state

    return (
      <div className={`${show ? 'slds-p-bottom_large' : ''} ${className}`} style={style}>
        <ExpandableSection
          open={show}
          title='Billing Stats (monthly)'
          inline={false}
          titleWidthClassName='slds-size_1-of-2'
          onClick={toggleShow}>
          <div className='slds-m-right_xx-large slds-m-top_small'>
            <div className='slds-m-left_small'>
              <div>
                <label for='month'>Month to generate report for</label>
                <input
                  id='month'
                  type='month'
                  name='month'
                  value={month}
                  max={todayYearMonth}
                  onChange={this.setMonth}
                  className='slds-input slds-text-color_weak month-input'
                  required
                />
              </div>
              <div className='slds-m-top_large'>
                <Button
                  type='brand'
                  minWidth={120}
                  onClick={this.generateReportForSelectedMonth}>
                  Generate
                </Button>
              </div>
            </div>
            {showReportGenerated &&
              <Modal
                ref={modalRef}
                heading={`Billing report for ${this.getMonthNameFromIndex(month.split('-')[1])} ${month.split('-')[0]}`}
                body={
                  fetchInProgress
                    ? <Spinner type='tail' />
                    : <CsvToHtmlTable
                        data={billingInfoFetched}
                        csvDelimiter=","
                        tableClassName="slds-table table-striped table-hover"
                        className='slds-m-bottom_medium'
                      />
                }
              />
            }
          </div>
        </ExpandableSection>
      </div>
    )
  }
}

MonthlyBillingStats.propTypes = {
  show: PropTypes.bool,
  toggleShow: PropTypes.func,
  className: PropTypes.string
}

MonthlyBillingStats.defaultProps = {
  show: false,
  className: ''
}



// WEBPACK FOOTER //
// ./src/components/messageplus/dashboard-reporting/MonthlyBillingStats.js